import { createSlice } from "@reduxjs/toolkit";
import { first } from "lodash";

const initialState = {
  name: undefined,
  first_name: undefined,
  phone: "",
  email: "",
  profile_pic: undefined,
  userData: undefined,
  loadingProfile: false,
  authToken: undefined,
  survey_id: undefined,
  routine_status: {},
  skincare_email_reminder: 0,
  is_subscription_valid: true,
};

const profileSlice = createSlice({
  name: "profileSlice",
  initialState,
  reducers: {
    userName: (state, actions) => {
      state.name = actions?.payload?.name;
    },
    userFirstName: (state, actions) => {
      state.first_name = actions?.payload?.name?.split(" ")
        ? first(actions?.payload?.name?.split(" "))
        : "";
    },
    userPhone: (state, actions) => {
      state.phone = actions?.payload?.phone;
    },
    userEmail: (state, actions) => {
      state.email = actions?.payload?.email;
    },
    userProfile_pic: (state, actions) => {
      state.profile_pic = actions?.payload?.profile_pic;
    },
    storeUserData: (state, actions) => {
      localStorage.setItem("userData", JSON?.stringify(actions?.payload));
      localStorage.setItem("user_email", actions?.payload?.email ?? "");
      localStorage.setItem("survey_id", actions?.payload?.active_survey_id ?? "");

      state.userData = actions?.payload;
    },
    toggleProfileLoading: (state, action) => {
      state.loadingProfile = action?.payload ?? false;
    },
    storeAuthToken: (state, actions) => {
      state.authToken = actions?.payload;
    },
    activeSurveyId: (state, actions) => {
      state.survey_id = actions?.payload;
    },
    routineStatus: (state, actions) => {
      state.routine_status = actions?.payload;
    },
    emailReminderStatus: (state, actions) => {
      state.skincare_email_reminder = actions?.payload;
    },
    isSubscriptionValid: (state, actions) => {
      state.is_subscription_valid = actions?.payload;
    },
  },
});

export const {
  userName,
  userPhone,
  userFirstName,
  userEmail,
  userProfile_pic,
  storeUserData,
  toggleProfileLoading,
  storeAuthToken,
  activeSurveyId,
  routineStatus,
  emailReminderStatus,
  isSubscriptionValid,
} = profileSlice.actions;

export default profileSlice.reducer;
